import React, { useState, useEffect, useRef } from 'react';
import './Carrousel.css';

function Carrousel({children, interval = 1000, showPagination, automatic}) {
    const itemRefs = useRef([]);
    const carrouselRef = useRef(null);
    const [currentItemCaroussel, setCurrentItemCaroussel] = useState(0);
    const [itemIsHovered, setItemIsHovered] = useState(false);

    useEffect(() => {
        if (automatic && !itemIsHovered) {
            const timeout = setTimeout(() => {
                if (currentItemCaroussel >= getLimitDisplayItems()) {
                    setCurrentItemCaroussel(0);
                }
                else {
                    setCurrentItemCaroussel(currentItemCaroussel+1)
                }
            }, interval)
            
    
            return () => clearTimeout(timeout);
        }
    }, [currentItemCaroussel]);

    const handleMouseEnter = () => {
        setItemIsHovered(true);
      };
    
      const handleMouseLeave = () => {
        setItemIsHovered(false);
      };

    const handlePagination = (step) => {
        let newPage = currentItemCaroussel + step;
        if (newPage < 0) {
            newPage = 0;
        }
        else if (newPage > getLimitDisplayItems()) {
            newPage = getLimitDisplayItems();
        }
        setCurrentItemCaroussel(newPage);
    }

    const getLimitDisplayItems = () => {
        if (carrouselRef.current === null) return 0;
        if (React.Children.toArray(children).length === 0) return 0;
        // On récupère la taille du conteneur
        const widthContainer = carrouselRef.current.offsetWidth;
        // On récupére la somme total de tous les items du carrousel
        const widthItems = itemRefs.current.reduce((totalWidth, item) => {
            if (item) {
              return totalWidth + item.offsetWidth + 50; // 50 : css gap attribut
            }
            return totalWidth;
        }, 0);
        // on récupère la taille d'un seul item en moyenne
        const widthOneItem = widthItems / itemRefs.current.length;
        // on enlève le nombre d'élément affichable pour s'arrêter au dernier élément pour
        // que le dernier élément ne se trouve pas tout à gauche
        // de cette façon le carroussel reste remplit et un vide ne s'affiche pas après le dernier item
        return Math.floor(React.Children.toArray(children).length - (widthContainer / widthOneItem)) + 1;
    }

    return ( 
        <div className="carrousel_component">
            <div className="carrousel_arrow_container">
                {showPagination && currentItemCaroussel > 0 &&  (
                    <span className="carroussel_arrow" onClick={()=>handlePagination(-1)}>{"<"}</span>
                )}
            </div>
            <div 
                className="carrousel_items"
                ref={carrouselRef}
            >
                {
                    React.Children.toArray(children).map((child, index) => {
                        return (
                            <div 
                                key={index}
                                className="carrousel_item"
                                onMouseEnter={()=>handleMouseEnter()}
                                onMouseLeave={()=>handleMouseLeave()}
                                ref={(element) => {
                                    itemRefs.current[index] = element;
                                }}
                                style={{transform: itemRefs.current[index] ? `translateX(-${currentItemCaroussel * (itemRefs.current[index].offsetWidth+50)}px)` : '' }}
                            >
                                {child}
                            </div>
                        )
                    })
                }
            </div>
            <div className="carrousel_arrow_container">
                {showPagination && currentItemCaroussel < getLimitDisplayItems() && <span className="carroussel_arrow" onClick={()=>handlePagination(1)}>{">"}</span>}
            </div>
        </div>
     );
}

export default Carrousel;